import React, { FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import { isNotificationCenterVisible } from '@src/redux/selectors/notificationCenter';
import { useAppDispatch, useAppSelector } from '@src/redux';
import { toggleNotificationCenterVisibility } from '@src/redux/actions/notificationCenter';
import Notifications from './Notifications';
import './styles.scss';

export const NotificationCenter: FC = () => {
  const isVisible = useAppSelector(isNotificationCenterVisible);

  const dispatch = useAppDispatch();

  return (
    <CSSTransition appear classNames="notification-center" in={isVisible} timeout={10000}>
      <div className="notification-center">
        <div
          className="notification-center__background"
          onClick={() => dispatch(toggleNotificationCenterVisibility())}
        />
        <div className="notification-center__content">
          <Notifications />
        </div>
      </div>
    </CSSTransition>
  );
};
